// extracted by mini-css-extract-plugin
export default {"tech":"Projects_tech__EqEoW","icon":"Projects_icon__+FpzK","seeMore":"Projects_seeMore__-AETw"};